export default __webpack_public_path__ + "static/media/dropdown_arrow.d5d3a07a.svg";